import TableTabSkeleton from "@/components/v2/molecules/admin/shared/TableTabSkeleton";

const IncomeTabSkeleton = () => (
  <TableTabSkeleton filterCount={5} tableColumns={12} rowCount={6} />
);

export default IncomeTabSkeleton;
